"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    sourceData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    // 进度条百分比
    orderPecent: function orderPecent() {
      var _this$sourceData = this.sourceData,
        salesTargetQty = _this$sourceData.salesTargetQty,
        confirmedQty = _this$sourceData.confirmedQty,
        orderQty = _this$sourceData.orderQty;
      return {
        salesTargetQty: salesTargetQty ? 100 : 0,
        confirmedQty: this.getPercent(confirmedQty, salesTargetQty),
        orderQty: this.getPercent(orderQty, salesTargetQty)
      };
    }
  },
  methods: {
    // 获取百分比
    getPercent: function getPercent(z, m) {
      if (z && z > m) {
        // 分子存在并且大于分母，不管分母是不是0，就是100进度
        return 100;
      } else if (z && m) {
        // const num = Math.ceil(z / m * 100)
        return Math.ceil(z / m * 100);
      } else {
        return 0;
      }
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    }
  }
};